import { Typography } from '@mui/material'
import './ErrorScreen.css'
import ErrorIllustration from './ErrorIllustration'

interface ErrorScreenProps {
  errorText?: string
  isDrawer?: boolean
  title?: string
}

function ErrorScreen({ errorText, isDrawer, title }: ErrorScreenProps) {
  return (
    <div className={`error-screen ${isDrawer ? 'error-screen-drawer' : ''}`}>
      <div className="error-screen-content">
        <ErrorIllustration className="error-screen-illustration" />
        <Typography variant="h6">{title ?? 'Error'}</Typography>
        <Typography variant="body1" color="text.secondary">
          {errorText ?? 'An error occurred. Please try again or contact support if the error persists.'}
        </Typography>
      </div>
    </div>
  )
}

export default ErrorScreen
